/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import classes from "../checkout.module.css";

import CustomerDetailBlock from "./customerDetailsBlock";
import NotesBlock from "./notesBlock";
import CartBlock from "./cartBlock";
import Button from "../../../../component/button";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../../component/breadcrumb";
import { Grid } from "@mui/material";

import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import { Tooltip } from "@mui/material";
import Input from "../../../../component/inputpm";
import currencyFormatter from "../../../../helper/currencyFormatter";

import NewCartBlock from "./newCartBlock";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import Loader from "../../../../component/loader";
import ManageCustomersHierarchy from "../../manageCustomers/manageCustomersHierarchy";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
// import { makeStyles } from '@mui/styles';
import OfferingProductSpecCharacteristicsExistingDialog from "../../../pm/component/specification/offeringProductSpecCharacteristicsExistingDialog";
import OfferingProductSpecCharacteristicsDialog from "../../../pm/component/specification/offeringProductSpecCharacteristicsDialog";
import { useNavigate } from "react-router-dom";

const Review = (props) => {
  const navigate = useNavigate();
  const [edit, setEdit] = useState({});
  const [bread, setBreadcrumb] = useState([]);
  const [showHierarchy, toggleShowHierarchy] = useState(false);
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();
  const [selectedItem, setSelectedItem] = useState({
    index: "",
    id: "",
    selectedCustomer: [],
    action: "",
  });
  // Check item max quantity
  const checkItemQuantity = (value, index, itemType, compType, compIndex) => {
    props.validator("", false);
    if (value < 1000) {
      props.changeQuantity(value, index, itemType, compType, compIndex);
    } else {
      props.validator(props.t("MAX_ITEMS_ERROR"), false);
    }
  };
  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };
  // Remove a component
  const removeComponent = (index, itemType, compType, compIndex) => {
    if (itemType === "SOL") {
      if (props.solutionList[index].promoId) {
        if (props.solutionList.length > 1) {
          for (let i = 0; i < props.solutionList.length; i++) {
            if (i !== index) {
              if (props.solutionList[i].promoId) {
                props.remove(index, itemType, compType, compIndex);
                break;
              } else {
                props.setPromoBan("");
                props.remove(index, itemType, compType, compIndex);
              }
            }
          }
        } else {
          props.setPromoBan("");
          props.remove(index, itemType, compType, compIndex);
        }
      } else {
        props.remove(index, itemType, compType, compIndex);
      }
    } else {
      props.remove(index, itemType, compType, compIndex);
    }
  };
  // const sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
  const sideMenu = props.sideMenu;
  const [cartData, setCartData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setBreadcrumb([
      {
        title: `${props.t("CHECKOUT")}: ${props.t("REVIEW")}`,
        url: "/checkout",
      },
    ]);
    setCartData(props.shoppingCart);
  }, []);
  const filterChildSpecs = (data) => {
    // if (!spec.productSpecificationRelationship) return spec;

    // // Keep only productSpecificationRelationship with category === "PSC_CUST_FACING"
    // spec.productSpecificationRelationship = spec.productSpecificationRelationship
    //     .filter(child => child.category && child.category.id === 'PSC_CUST_FACING')
    //     .map(child => filterChildSpecs(child)); // Recurse!

    // return spec;

    // Base case: if the object has a category and it's not PSC_CUST_FACING
    if (data.category?.id !== "PSC_CUST_FACING") {
      data.productSpecCharacteristic = [];
    }

    // If there are productSpecificationRelationship, apply recursively
    if (Array.isArray(data.productSpecificationRelationship)) {
      data.productSpecificationRelationship.forEach(filterChildSpecs);
    }

    return data;
  };
  const updateCategory = (spec) => {
    // If the object has a category and it matches, update it
    if (spec.category && spec.category.id === "Customer Facing") {
      spec.category.id = "PSC_CUST_FACING";
    }

    // If it has productSpecificationRelationship, process each child recursively
    if (
      spec.productSpecificationRelationship &&
      spec.productSpecificationRelationship.length
    ) {
      spec.productSpecificationRelationship =
        spec.productSpecificationRelationship.map(updateCategory);
    }

    return spec;
  };
  const removePSFromCart = (item) => {};
  const changePSQuantity = async (e, item) => {
    if (e.target.value > 0) {
      setLoading(true);
      var payload = {
        cartItem: [{ ...item }],
      };
      payload.cartItem[0].productOffering.quantity = +e.target.value;
      payload.cartItem[0].action = "MODIFY";
      BusApiCall(
        "PATCH",
        `${constants.busPublicServiceUrl}/shoppingCart/${cartData[0].id}`,
        payload,
      )
        .then(async (res) => {
          var tempCartData = res.data;
          if (
            tempCartData &&
            tempCartData.cartItem &&
            tempCartData.cartItem.length > 0
          ) {
            for (var s = 0; s < tempCartData.cartItem.length; s++) {
              if (
                tempCartData.cartItem[s].productOffering.includedItems &&
                tempCartData.cartItem[s].productOffering.includedItems.length >
                  0
              ) {
                for (
                  var p = 0;
                  p <
                  tempCartData.cartItem[s].productOffering.includedItems.length;
                  p++
                ) {
                  var filteredCategories = await updateCategory(
                    tempCartData.cartItem[s].productOffering.includedItems[p]
                      .productSpec,
                  );
                  tempCartData.cartItem[s].productOffering.includedItems[
                    p
                  ].productSpec = filteredCategories;
                  // if (tempCartData.cartItem[s].productOffering.includedItems[p].productSpec && tempCartData.cartItem[s].productOffering.includedItems[p].productSpec.category && tempCartData.cartItem[s].productOffering.includedItems[p].productSpec.category.id === 'PSC_CUST_FACING') {
                  //     const filteredJson = await filterChildSpecs(tempCartData.cartItem[s].productOffering.includedItems[p].productSpec);
                  //     tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = filteredJson;
                  // } else {
                  //     tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = {};
                  // }
                  const cleanedData = await filterChildSpecs(
                    tempCartData.cartItem[s].productOffering.includedItems[p]
                      .productSpec,
                  );
                  tempCartData.cartItem[s].productOffering.includedItems[
                    p
                  ].productSpec = cleanedData;
                }
              }
            }
          }
          setCartData([tempCartData]);
          props.setCart([tempCartData]);
          setLoading(false);
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            props.setErrorMessage(err.response.data.message, false);
          } else {
            props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
          }
          setLoading(false);
        });
    }
  };
  const confirmQuote = () => {
    setLoading(true);
    var payload = {
      statusId: "QUO_REVIEW",
    };
    if (cartData && cartData.length > 0 && cartData[0].id) {
      BusApiCall(
        "PUT",
        `${constants.busV44UrlPublic}/quote/${cartData[0].id}/updateStatus`,
        payload,
      )
        .then((res) => {
          props.setErrorMessage(props.t("QUOTE_STATUS_UPDATED"), true);
          setLoading(false);
          navigate("/quote");
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            props.setErrorMessage(err.response.data.message, false);
          } else {
            props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
          }
          setLoading(false);
        });
    }
  };

  const [
    selectedProductSpecificationOffering,
    setSelectedProductSpecificationOffering,
  ] = useState({});
  const [selectedProductSpecification, setSelectedProductSpecification] =
    useState({});
  const [showProductSpecification, setShowProductSpecification] =
    useState(false);
  const [selectedCharacteristics, setSelectedCharacteristics] = useState([]);

  const openProductSpecification = (offering, product) => {
    // setSelectedProductSpecificationOffering(offering);
    // setSelectedProductSpecification(product);
    // setShowProductSpecification(true);
    const oldData = [...cartData];
    var cartItem = oldData[0].cartItem;
    var index = cartItem.findIndex((x) => x.index === offering.index);
    var selectedCartItem = cartItem[index];
    var productIndex = selectedCartItem.productOffering.includedItems.findIndex(
      (x) => x.id === product.id,
    );
    var selectedProduct =
      selectedCartItem.productOffering.includedItems[productIndex];
    if (selectedProduct.expandChar) {
      selectedProduct.expandChar = false;
    } else {
      selectedProduct.expandChar = true;
    }
    selectedCartItem.productOffering.includedItems[productIndex] =
      selectedProduct;
    cartItem[index] = selectedCartItem;
    oldData[0].cartItem = cartItem;
    setCartData(oldData);
    props.setCart(oldData);
  };

  const handleCloseSpecificationDialog = () => {
    // setSelectedProductSpecificationOffering({});
    // setSelectedProductSpecification({});
    // setShowProductSpecification(false);
  };

  const handleCharacteristicsUpdate = (
    updatedCharacteristics,
    offering,
    product,
  ) => {
    setLoading(true);

    const oldData = [...cartData];
    const cartItem = oldData[0].cartItem;
    const index = cartItem.findIndex((x) => x.index === offering.index);

    const selectedCartItem = cartItem[index];
    const productIndex =
      selectedCartItem.productOffering.includedItems.findIndex(
        (x) => x.id === product,
      );
    const selectedProduct =
      selectedCartItem.productOffering.includedItems[productIndex];
    if (selectedProduct.productSpec && selectedProduct.productSpec.category) {
      // if (selectedProduct.productSpec.category.id === 'PSC_CUST_FACING') {
      selectedProduct.productCharsOverride = [];
      updatedCharacteristics.forEach((char) => {
        selectedProduct.productCharsOverride.push({
          name: char.name,
          value: char.value,
          specId: char.specId,
          id: char.id,
        });
      });
      // }
    }
    selectedCartItem.productOffering.includedItems[productIndex] =
      selectedProduct;
    selectedCartItem.action = "MODIFY";
    const payload = {
      cartItem: [],
    };
    if (props.providerType === "SOLUTION_PROVIDER") {
      payload.tenantId = localStorage.getItem("selectedSalesChannel");
    }
    payload.cartItem.push(selectedCartItem);
    console.log("check final payload", payload);
    BusApiCall(
      "PATCH",
      `${constants.busPublicServiceUrl}/shoppingCart/${cartData[0].id}`,
      payload,
    )
      .then(async (res) => {
        props.setErrorMessage(
          props.t("CHARACTERISTIC_UPDATED_SUCCESSFULLY"),
          true,
        );
        var tempCartData = res.data;
        if (
          tempCartData &&
          tempCartData.cartItem &&
          tempCartData.cartItem.length > 0
        ) {
          for (var s = 0; s < tempCartData.cartItem.length; s++) {
            if (
              tempCartData.cartItem[s].productOffering.includedItems &&
              tempCartData.cartItem[s].productOffering.includedItems.length > 0
            ) {
              for (
                var p = 0;
                p <
                tempCartData.cartItem[s].productOffering.includedItems.length;
                p++
              ) {
                var filteredCategories = await updateCategory(
                  tempCartData.cartItem[s].productOffering.includedItems[p]
                    .productSpec,
                );
                tempCartData.cartItem[s].productOffering.includedItems[
                  p
                ].productSpec = filteredCategories;
                // if (tempCartData.cartItem[s].productOffering.includedItems[p].productSpec && tempCartData.cartItem[s].productOffering.includedItems[p].productSpec.category && tempCartData.cartItem[s].productOffering.includedItems[p].productSpec.category.id === 'PSC_CUST_FACING') {
                //     const filteredJson = await filterChildSpecs(tempCartData.cartItem[s].productOffering.includedItems[p].productSpec);
                //     tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = filteredJson;
                // } else {
                //     tempCartData.cartItem[s].productOffering.includedItems[p].productSpec = {};
                // }
                const cleanedData = await filterChildSpecs(
                  tempCartData.cartItem[s].productOffering.includedItems[p]
                    .productSpec,
                );
                tempCartData.cartItem[s].productOffering.includedItems[
                  p
                ].productSpec = cleanedData;
              }
            }
          }
        }
        setCartData([tempCartData]);
        props.setCart([tempCartData]);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(false);
      });
  };

  const selectCustomers = (data) => {
    var obj = {
      name: data.accountName,
      partyId: data.partyId,
    };
    var cart = cartData[0];
    var pIndex = cart.cartItem.findIndex((x) => x.index === selectedItem.index);
    if (pIndex > -1) {
      cart.cartItem[pIndex].productOffering.locationDetail = obj;
      props.setCart([cart]);
      setSelectedItem({
        index: "",
        id: "",
        action: "",
        selectedCustomer: [],
      });
      toggleShowHierarchy(false);
      // var iIndex = cart.cartItem[pIndex].productOffering.includedItems.findIndex(y => y.id === selectedItem.id);
      // if (iIndex > -1) {
      //     cart.cartItem[pIndex].productOffering.includedItems[iIndex].locationDetail = obj;
      //     props.setCart([cart]);
      //     setSelectedItem({
      //         index: '',
      //         id: '',
      //         action: '',
      //         selectedCustomer: []
      //     })
      //     toggleShowHierarchy(false);
      // }
    }
  };

  const selectItem = (index, id, action) => {
    if (action === "add") {
      setSelectedItem({
        index: index,
        id: id,
        action: action,
        selectedCustomer: [],
      });
      toggleShowHierarchy(true);
    }
    if (action === "edit") {
      var oldItem = {};
      var cart = cartData[0];
      var pIndex = cart.cartItem.findIndex((x) => x.index === index);
      if (pIndex > -1) {
        // var iIndex = cart.cartItem[pIndex].productOffering.includedItems.findIndex(y => y.id === id);
        // if (iIndex > -1) {
        //     oldItem = cart.cartItem[pIndex].productOffering.includedItems[iIndex].locationDetail;
        // }
        oldItem = cart.cartItem[pIndex].productOffering.locationDetail;
      }
      setSelectedItem({
        index: index,
        id: id,
        action: action,
        selectedCustomer: [oldItem],
      });
      toggleShowHierarchy(true);
    }
    if (action === "delete") {
      var cart = cartData[0];
      var pIndex = cart.cartItem.findIndex((x) => x.index === index);
      if (pIndex > -1) {
        // var iIndex = cart.cartItem[pIndex].productOffering.includedItems.findIndex(y => y.id === id);
        // if (iIndex > -1) {
        //     delete cart.cartItem[pIndex].productOffering.includedItems[iIndex].locationDetail;
        //     props.setCart([cart]);
        // }
        delete cart.cartItem[pIndex].productOffering.locationDetail;
        props.setCart([cart]);
      }
    }
  };
  return (
    <React.Fragment>
      {/* <h2 className={classes.checkoutTitle}> {`Checkout: Review`}</h2> */}
      <div className={"newContentWrapper checkPageContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={bread} />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
      <div style={{ marginTop: sideMenu ? "25px" : "75px" }}>
        {/* Customer info block */}
        <CustomerDetailBlock
          editOption={true}
          stage={props.stage}
          edit={() => {
            props.edit(0);
          }}
          customerDetails={props.customerDetails}
        />
        <br />
        <br />
        {/* Cart items details */}
        {/* <CartBlock
                    componentList={props.componentList}
                    solutionList={props.solutionList}
                    accessoryList={props.accessoryList}
                    remove={removeComponent}
                    changeQuantity={checkItemQuantity}
                    changeDiscount={props.changeDiscount}
                    edit={edit}
                    orderStatus={props.orderStatus}
                    tenantId={props.tenantId}
                    loggedInUserType={props.loggedInUserType}
                    providerType={props.providerType}
                /> */}

        <NewCartBlock
          cartData={cartData}
          removePSFromCart={removePSFromCart}
          changeQuantity={changePSQuantity}
          edit={edit}
          providerType={props.providerType}
          loggedInUserType={props.loggedInUserType}
          selectItem={selectItem}
          screen={"checkout"}
          type={"NewActivation"}
          openProductSpecification={(item, aItem) =>
            openProductSpecification(item, aItem)
          }
          handleCharacteristicsUpdate={handleCharacteristicsUpdate}
        />

        <div style={{ margin: "25px 0" }}>
          <button
            onClick={() => {
              setEdit({ quantity: !edit.quantity, item: !edit.item });
            }}
            className={classes.button}
            style={{ marginTop: "1px", marginRight: "10px" }}
          >
            {edit.quantity ? props.t("Done") : props.t("EDIT_QUANTITY")}
          </button>
          <Button
            onClick={() => {
              navigate({ pathname: `/newOrder`, state: "checkout" });
            }}
          >
            {props.t("ADD_OFFERINGS")}
          </Button>
        </div>
        {/* Order notes and agent id */}
        <NotesBlock
          stage={props.stage}
          notes={props.notes}
          edit={props.edit}
          loggedInUserType={props.loggedInUserType}
          onChangeCustomerOrderNumber={props.onChangeCustomerOrderNumber}
          inputAlphaNumeric={props.inputAlphaNumeric}
        />
        <div align="right">
          <Button
            onClick={() => {
              props.placeOrder();
            }}
          >
            {props.quoteEnabled
              ? props.t("CREATE_QUOTE")
              : props.t("PLACE_ORDER")}
          </Button>
        </div>
      </div>
      <Loader loading={loading} />
      {showHierarchy && (
        <Dialog
          disableScrollLock={true}
          maxWidth={"sm"}
          PaperComponent={DraggableDialogPaper}
          fullWidth={true}
          open={showHierarchy}
          aria-labelledby="import-dialog-title"
          // PaperProps={{
          //     className: classess.resizablePaper
          // }}
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {props.t("SELECT_CUSTOMER")}
          </DialogTitle>
          <DialogContent dividers style={{ height: "500px" }}>
            <ManageCustomersHierarchy
              screen="products"
              subScreen="oldOfferingFilter"
              selectCustomers={selectCustomers}
              customerData={selectedItem.selectedCustomer}
              offeringBan={props.customerDetails.ban}
              // offeringCustomer={[props.orderCustomer.clientId]}
              // stage={this.state.stage}
              // next={this.selectCustomerClose}
              // // back={this.back}
              // selectedTreeItems={this.state.selectedTreeItems}
              // customerDetails={this.state.customerDetails}
              // selectedPaymentMethod={this.state.selectedPaymentMethod}
              // resetSelecteddata={this.resetSelecteddata}
              // closeDialog={this.closeDialog}
              // parentTenantId={this.state.parentTenantId}

              // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? [this.props.ecommerceCustData.partyId] : this.state.offeringCustomersList}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => toggleShowHierarchy(false)}>
              {props.t("CANCEL")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* {showProductSpecification &&
                <>
                    <OfferingProductSpecCharacteristicsExistingDialog t={props.t} open={showProductSpecification} productId={selectedProductSpecification.id} productName={selectedProductSpecification.name} onClose={handleCloseSpecificationDialog} componentProductCharacteristics={selectedProductSpecification.productSpec ? selectedProductSpecification.productSpec : {}} onCharacteristicsChange={handleCharacteristicsUpdate} changedCharacteristics={selectedCharacteristics || []} screen={edit && edit.quantity ? 'checkout' : 'order'} />
                </>
            } */}
    </React.Fragment>
  );
};

// Get data from redux store
const mapStateToProps = (state) => {
  return {
    solutionList: state.cart.solutions,
    accessoryList: state.cart.accessories,
    componentList: state.cart.componentList,
    tenantId: state.auth.tenantId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    shoppingCart: state.cart.shoppingCart,
    shoppingQuote: state.quote.shoppingQuote,
    quoteEnabled: state.auth.quoteEnabled,
    sideMenu: state.auth.sideMenu,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    clearCart: () => dispatch({ type: actionTypes.CLEAR_CART }),
    remove: (index, itemType, compType, compIndex) =>
      dispatch({
        type: actionTypes.REMOVE_ITEM,
        index,
        itemType,
        compType,
        compIndex,
      }),
    changeQuantity: (value, index, itemType, compType, compIndex) =>
      dispatch({
        type: actionTypes.CHANGE_QUANTITY,
        value,
        index,
        itemType,
        compType,
        compIndex,
      }),
    changeDiscount: (value, index, itemType, compType, compIndex) =>
      dispatch({
        type: actionTypes.CHANGE_DISCOUNT,
        value,
        index,
        itemType,
        compType,
        compIndex,
      }),
    setPromoBan: (id) => dispatch({ type: actionTypes.CHECK_PROMO_BAN, id }),
    setCart: (cart) => dispatch({ type: actionTypes.SET_CART, cart }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(Review));
